module.exports = __webpack_public_path__ + "img/8.06279f0f.png";